import { lazyLoad } from 'app/utils/loadable'

export const ManageSoftwareSubscriptionPage = lazyLoad(
  () => import('./index'),
  module => module.ManageSoftwareSubscriptionPage
)
